export const KEYCLOAK_ROLE_USER = 'ROLE_USER';
export const KEYCLOAK_ROLE_UPLOADER = 'ROLE_UPLOADER';
export const KEYCLOAK_ROLE_REVIEWER = 'ROLE_REVIEWER';
export const KEYCLOAK_ROLE_JUDGE = 'ROLE_JUDGE';
export const KEYCLOAK_ROLE_ADMIN = 'ROLE_ADMIN';
export const KEYCLOAK_ROLE_PREMIUM_USER = 'ROLE_PREMIUM_USER';
export const KEYCLOAK_ROLES = [
  KEYCLOAK_ROLE_UPLOADER,
  KEYCLOAK_ROLE_USER,
  KEYCLOAK_ROLE_ADMIN,
  KEYCLOAK_ROLE_REVIEWER,
  KEYCLOAK_ROLE_JUDGE,
  KEYCLOAK_ROLE_PREMIUM_USER,
];
